import { __assign, __rest } from "tslib";
import React from 'react';
import { Url } from '@wix/da-url';
import { ResourceType } from '../types/resource';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
export var CommentLink = function (_a) {
    var _b;
    var comment = _a.comment, children = _a.children, restProps = __rest(_a, ["comment", "children"]);
    return (React.createElement(BiLink, __assign({ href: Url.commentLink(comment.typeId, comment.itemId, comment.commentId), biData: BiData({
            evid: 100,
            typeid: ResourceType.COMMENT,
            itemid: comment.commentId,
            creatorid: (_b = comment.user) === null || _b === void 0 ? void 0 : _b.useridUuid,
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
        }) }, restProps), children));
};
CommentLink.displayName = 'CommentLink';
export default CommentLink;
//# sourceMappingURL=CommentLink.js.map